import React, { Component } from "react";
import { connect } from "react-redux";
import { Redirect } from "react-router-dom";
import styled from "styled-components";
import { convertStringToElements } from "@vds/html-parsers";

import { setA11yContent } from "../../NavigationHelper/actions";
import { checkIfMDNisSMSCapable } from "../../DownloadAndDelete/actions";
import { setBreadcrumbList } from "common-components/BreadCrumbs/actions";
import { formatPhoneNumber } from "utils/formatPhoneNumber";
import { checkNestedObject } from "utils/checkNestedObject";
import { replaceHashValues } from "utils/replaceHashValues";

import CommonHeader from "common-components/Header";
import { TitleLockup } from "@vds/type-lockups";
import { isMobile } from "utils/style";
import { Button } from "@vds/buttons";
import Container from "common-components/Container";
import StyledLink from "common-components/StyledLink";

class AuthorizedAgentDownloadAffidavit extends Component {
  componentDidMount() {
    if (checkNestedObject(this.props.pageContent, "sc_pagetitle")) {
      this.props.setA11yContent("affidavit", this.props.pageContent.sc_pagetitle);
    }
  }

  renderCustomerIdentifier = ({ serviceType, accountName, mtn, accountId }) => {
    if (serviceType === "ott") {
      return `with Customer Identifier ${accountId}`;
    }
    if (serviceType === "vzw") {
      return `${accountName} with Customer Identifier ${formatPhoneNumber(mtn)}`;
    }
    if (accountId) {
      return `${accountName} with Customer Identifier ${accountId.replace(/.(?=.{4,}$)/g, "X")}`;
    }
    return "-";
  };

  render() {
    if (!checkNestedObject(this.props, "pageContent", "section_title")) {
      return <Redirect to="/privacy/secure/authorized-agent" />;
    }
    const { section_title, section_description, buttons } = this.props.pageContent;
    const { agentSelectedCustomer } = this.props;

    return (
      <Container>
        <div style={{ maxWidth: "422px" }}>
            {/* DPCMP - 3792, 3791*/}
          <TitleLockup
            surface='light'
            textAlignment='left'
            viewport={isMobile ? "mobile" : "desktop"}
            data={{
              title: {
                size: 'titleLarge',
                bold: false,
                children: convertStringToElements(section_title)
              },
              subtitle: {
                size: 'bodyLarge',
                children:
                  <Div data-qm-encrypt="true" >
                    {convertStringToElements(
                      replaceHashValues(section_description, {
                        accountName: this.renderCustomerIdentifier(agentSelectedCustomer)
                      })
                    )}
                  </Div>
              }

            }}

          />
          <Button
                style={{ marginTop: "16px", fontFamily: 'Verizon-NHG-eDS, Helvetica, Arial, sans-serif' }}
                background={buttons[0].type}
                onClick={() => this.props.history.push({
                  pathname:"/privacy/secure/authorized-agent/download-amount",
                  state: {
                    confirmAuth: true, 
                    fromAuthorizedAgent: true, 
                    customerHistory: this.props.location.state.customerHistory
                  }
                })}
              >
               {buttons[0].text}
          </Button>
          {/* <StyledLink
            background={buttons[0].type}
            style={{ marginTop: "16px" }}
            to={{
              pathname: "/privacy/secure/authorized-agent/download-amount",
              state: { confirmAuth: true, fromAuthorizedAgent: true, customerHistory: this.props.location.state.customerHistory }
            }}
          >
            {buttons[0].text}
          </StyledLink> */}
        </div>
      </Container>
    );
  }
}

const mapStateToProps = ({
  pageContent: { affidavit_confirmation: pageContent },
  agentSelectedCustomer
}) => ({
  pageContent,
  agentSelectedCustomer
});

export default connect(
  mapStateToProps,
  { setA11yContent, checkIfMDNisSMSCapable, setBreadcrumbList }
)(AuthorizedAgentDownloadAffidavit);


const Header = styled(CommonHeader)`
  max-width: 598px;
  font-size: 48px;
  line-height: 48px;
  margin-bottom: 12px;
  font-family:'Verizon NHG DS', Helvetica, Arial, sans-serif;
  font-weight: 300`;

const Div = styled.div`
  margin: 40px 0;

  p {
    margin: 12px 0;
  }
`;
